import { DataBean } from "../DataBean";

export class AttentionService extends DataBean {

    // public async getAttentionServiceCatalog(idAttentionPoint: number): Promise<any> {
    //     return this.getCustomService(
    //         "QuickTurnService", 
    //         "java.util.List_getAttentionServiceCatalog_Number", 
    //         [idAttentionPoint]);
    // }

    public async getTreeForAttentionID(idAttentionOffice: number, idCharacterization: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "com.advantage.shared.Tree_getTreeForAttentionID_Number_Number",
            [idAttentionOffice, idCharacterization]);
    }

    public async getAttentionIDChilds(idln: number, State: number, idAttentionOffice: number, idCharacterization: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "java.util.List_getAttentionIDChilds_Number_Number_Number_Number",
            [idln, State, idAttentionOffice, idCharacterization]);
    }

}
